import React from "react";
import { Routes, Route } from "react-router-dom";
import HelperRoutes from "@/helper/HelperRoutes";
import publicRoutes from "./Public.routes";
import StudentRoutes from "./Student.routes";
import PoRoutes from "./Po.routes";
import HrRoutes from "./Hr.routes";
import { pages } from "@/routes/pageImports";

const renderRoutes = (routes) => {
  return routes.map(({ path, element }) => (
    <Route key={path} path={path} element={element} />
  ));
};

const AppRoutes = () => {
  // Retrieve dynamically generated routes
  const { studentAuthRoutes,studentOnboardingRoutes, studentPrivateRoutes } = StudentRoutes();
  const { poAuthRoutes, poOnboardingRoutes, poPrivateRoutes } = PoRoutes();
  const { hrAuthRoutes, hrOnboardingRoutes, hrPrivateRoutes } = HrRoutes();

  // Combine all routes
  const allRoutes = [
    ...publicRoutes,
    ...studentAuthRoutes,
    ...studentOnboardingRoutes,
    ...studentPrivateRoutes,
    ...poAuthRoutes,
    ...poOnboardingRoutes,
    ...poPrivateRoutes,
    ...hrAuthRoutes,
    ...hrOnboardingRoutes,
    ...hrPrivateRoutes,
  ];

  return (
    <div className="containerStyle">
      <div className="innerContainerStyle">
        <HelperRoutes />
        <Routes>
          {renderRoutes(allRoutes)}
          <Route path="*" element={<pages.PageNotFound />} />
        </Routes>
      </div>
    </div>
  );
};

export default AppRoutes;
